module.exports = __webpack_public_path__ + "src/assets/games/42/254.jpg";